import styled from 'styled-components';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { NextSeo } from 'next-seo';
import { timestamp } from 'src/utils/helper';
import { GET } from 'src/utils/service';
import { WEB_NAME } from 'src/constants/layout';
import dynamic from 'next/dynamic';
import { DATALAYER_TYPE } from 'src/utils/datalayer/send-datalayer';
import { useRouter } from 'next/router';
import { APP_IMG } from 'src/constants';
const Carousels = dynamic(import('src/components/carousels'));
const CardV = dynamic(import('src/components/cards/card-v'));
const Layout = dynamic(import('src/components/layouts'));

const EmptyArticle = ({ lastNews }: any) => {
  const router = useRouter();

  const [dataLatestNews, setDataLatestNews] = useState(lastNews);
  const [navbarDataFetch, setNavbarDataFetch]: any = useState(null);

  useEffect(() => {
    if (!lastNews) {
      (async () => {
        try {
          const resData = await Promise.all([GET('/api/v1.0/navigations/menu-nav'), GET('/api/v1.0/categories/latest-news')]);
          if (!_.isEmpty(resData[0])) setNavbarDataFetch(resData[0]);
          if (!_.isEmpty(resData[1])) setDataLatestNews(resData[1]);
        } catch (err) {
          console.error(`${timestamp()}==========> EMPTY_ARTICLE ERROR : ${err}`);
        }
      })();
    }
  }, []);
  return (
    <Layout data={{ header: navbarDataFetch, footer: navbarDataFetch }}>
      <NextSeo noindex={true} nofollow={true} title={`ไม่มีข่าวนี้หรือถูกลบไปแล้ว >>> ${WEB_NAME}`} description={`ไม่มีข่าวนี้หรือถูกลบไปแล้ว >>> ${WEB_NAME}`} />
      <EmptyWrapper className='empty-article'>
        <div className='container'>
          <img className='no-article' src={`${APP_IMG}/images/logo.png`} loading='lazy' alt='no-article' title='no-article' width='100%' height='100' />
          {/* ----------------------------- LATEST_NEWS  --------------------------------- */}
          {Array.isArray(dataLatestNews) && (
            <Carousels slideShow={4}>
              {dataLatestNews.slice(0, 6).map((item, index) => (
                <div key={index} className='card-item'>
                  <CardV
                    data={item}
                    showTitle={true}
                    showBlurb={false}
                    showByline={false}
                    showTime={false}
                    showCountview={false}
                    external={false}
                    //! DATALAYER
                    eventDataLayer={{
                      type: DATALAYER_TYPE.TRACK_INDEX,
                      router: router?.pathname,
                      section: 'section-1',
                      data: {
                        title: item?.title,
                        heading: 'ข่าวล่าสุด',
                        index: index + 1
                      }
                    }}
                  />
                </div>
              ))}
            </Carousels>
          )}
        </div>
      </EmptyWrapper>
    </Layout>
  );
};

const EmptyWrapper = styled.div`
  display: block;
  text-align: center;
  margin: 30px 0;
  height: 100vh;
  .card-item {
    padding: 0 5px;
  }

  .card-item {
    text-align: start;
  }

  .no-article {
    width: auto;
    margin: 100px auto;
    opacity: 0.3;
    -webkit-filter: grayscale(40%);
    filter: grayscale(40%);
    @media (max-width: 475px) {
      margin: 38px auto;
    }
  }
`;
export default EmptyArticle;
